import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes } from "react-router"
import Index from "src/pages/Index/Index"
import Game from "src/pages/Game/Game"
import Form from "src/pages/Form/Form"
import './styles/general.scss'
import MidGame from "src/pages/MidGame/MidGame"
import LocationProvider from "src/hoc/LocationProvider/LocationProvider"
import TimerProvider from "src/hoc/TimerProvider/TimerProvider"

const App = () => {

    useEffect(() => {

        const onTouchEnd = (event: any) => {
            const element: HTMLInputElement | null = document.querySelector("#chat-input")
            if (element === null) return
            const touch = event.changedTouches[0] // Берём первое касание
            const touchX = touch.clientX
            const touchY = touch.clientY

            // Получаем размеры и позицию элемента
            const rect = element.getBoundingClientRect()

            // Проверяем, находится ли касание вне границ элемента
            const isOutside =
                touchX < rect.left ||
                touchX > rect.right ||
                touchY < rect.top ||
                touchY > rect.bottom

            if (isOutside) {
                element.blur()
            } else {
                console.log('Touchend произошёл внутри элемента!')
            }
        }

        window.addEventListener("touchend", onTouchEnd)

        return () => {
            window.removeEventListener("touchend", onTouchEnd)
        }
    }, [])

    return (
        <BrowserRouter>
            <Routes>
                <Route
                    element={<LocationProvider/>}
                >
                    <Route
                        element={<TimerProvider/>}
                    >
                        <Route
                            path={"/"}
                            element={<Index/>}
                        />
                        <Route
                            path={"/game"}
                            element={<Game/>}
                        />
                        <Route
                            path={"/mid-game"}
                            element={<MidGame/>}
                        />
                        <Route
                            path={"/form"}
                            element={<Form/>}
                        />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default App